import { generateUtilityClass, generateUtilityClasses } from "@suid/base";
export function getDrawerUtilityClass(slot) {
    return generateUtilityClass("MuiDrawer", slot);
}
const drawerClasses = generateUtilityClasses("MuiDrawer", [
    "root",
    "docked",
    "paper",
    "paperAnchorLeft",
    "paperAnchorRight",
    "paperAnchorTop",
    "paperAnchorBottom",
    "paperAnchorDockedLeft",
    "paperAnchorDockedRight",
    "paperAnchorDockedTop",
    "paperAnchorDockedBottom",
    "modal",
]);
export default drawerClasses;
